//
// TODO: Move this component out of Inputs
//
import * as React from 'react'

import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  checked: boolean
  disabled?: boolean
  onClick?: React.MouseEventHandler
}

const CheckBox = ({ checked, disabled = false, onClick }: Props) => {
  const onDefaultClick: React.MouseEventHandler = (event) => {
    if (disabled) return

    onClick && onClick(event)
  }

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      onClick={onDefaultClick}
      tabIndex={0}
      className={cx('checkbox', {
        checked,
        disabled,
      })}
    />
  )
}

export default observer(CheckBox)
